import(/* webpackMode: "eager", webpackExports: ["AddReviewPageClient"] */ "/app/src/app/(ru)/masterclasses/[wordId]/add-review/add-review-page-client.tsx");
